<template>
  <v-card  :class="[this.showMsgNoData ? 'noData' : '']" style="background: #3C454D!important; min-height: 200px;">
    <v-card-title primary class="title white--text">
      <h3 class="headline mb-0">
        <v-icon class="mb-1" color="white">{{icon}}</v-icon>
        {{title}}
      </h3>
    </v-card-title>
    <v-card-text primary-text style="position: relative;" class="card_c">
      <div v-if="!showMsgNoData">
        <canvas :id="this.customId" style="width: 100%; heigth: 100%;"></canvas>
      </div>
      <h4 v-if="showMsgNoData" style="color: wheat;">
        Sem Dados para <strong>Análise</strong>
      </h4>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: [
    "conta",
    "labels",
    "data",
    "backgroundColor",
    "borderColor",
    "customId",
    "title",
    "icon"
  ],
  data: () => ({
    barChart: {
      type: "bar",
      data: {
        labels: [],
        datasets: []
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    },
    total: 0,
    showMsgNoData: false,
  }),
  watch: {
    'data': {
      handler: function (val, oldVal) {
        if(val && val.length > 0){
            this.begin();
        }
      },
      deep: true
    }
  },
  mounted: function() {
    this.$nextTick(function() {
    });
  },
  methods: {
    begin: async function(){
      try{
        new Promise( async (resolve,reject) =>{
          var ctxpie = document.getElementById(this.customId);
          if(ctxpie){
            resolve(ctxpie);
          }
        }).then(async (ctxpie) =>{
          await this.setData();
          Chart.defaults.global.legend.display = true;
          let barChart = new Chart(ctxpie, this.barChart);
        })        
      }
      catch(err){
        console.log(`Erro ao tentar montar barChart: \n\n ${err}`)
      }

    },
    setData: function() {
      if (this.labels != undefined) {
        if(this.labels.length == 0){
          this.showMsgNoData = true;
        }else{
          this.showMsgNoData = false;
          this.barChart.data.labels = this.labels;
          this.setDatasets();
        }
      }else{
          this.showMsgNoData = true;
      }
    },
    setDatasets: function() {
      if (this.data != undefined && this.data.length > 0) {
        
        let datasets = [];
        for (let i = 0; i < this.data.length; i++) {
          let props = {};
          const element = this.data[i];
          props["label"] = element.label;
          props["data"] = element.data;
          props["backgroundColor"] = element.backgroundColor;
          props["borderColor"] = element.borderColor;
          props["borderWidth"] = element.borderWidth;
          datasets.push(props);
        }
        this.barChart.data.datasets = datasets.slice();
      } else {
     
        this.barChart.data.datasets = [];
      }
    }
  }
};
</script>
<style>
.noData{
  position: relative;
}
.noData .card_c{
  position: absolute!important;
  bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/dashBoard/charts/chartBar/ChatBar.vue